module.exports = __webpack_public_path__ + "static/media/audio.5ae2299.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio.mp3
// module id = Mrhs
// module chunks = 5